import { api } from '@/modules/apiv2';

export default {
  state: {
    subscriber: null,
    subscribers: { BackendSubscriber: null, AppSubscribers: [] },
    connectedSubscribers: {},
  },

  getters: {
    subscriber(state) {
      return state.subscriber;
    },

    subscribers(state) {
      return state.subscribers;
    },

    connectedSubscribers(state) {
      return state.connectedSubscribers;
    },
  },

  mutations: {
    setSubscriber(state, subscriber) {
      state.subscriber = subscriber;
    },

    setSubscribers(state, subscribers) {
      state.subscribers = subscribers;
    },

    setConnectedSubscribers(state, connectedSubscribers) {
      state.connectedSubscribers = connectedSubscribers;
    },
  },

  actions: {
    getSubscribers({ commit, getters }, connectionId) {
      const endpoint = getters.connectionsEndpoint;

      return api
        .get(`${endpoint}/${connectionId}/subscribers`)
        .then((data) => {
          commit('setSubscribers', data);
          return data;
        })
        .catch(() => {
          commit('setSubscribers', { BackendSubscriber: null, AppSubscribers: [] });
        });
    },

    async populatedConnectedSubscribers({ commit, getters }) {
      let connectedAppSub = { AppSubscribers: {} };
      connectedAppSub['RmsConsumers'] = {};
      connectedAppSub.RmsConsumers['All Consumers'] = [];

      if (getters.currentUserIsOwner) {
        let owner = getters.config;
        connectedAppSub['RmsOwners'] = {};
        connectedAppSub.RmsOwners['All Owners'] = [];
        connectedAppSub.RmsOwners['All Owners'].push(owner);

        let acceptedConnections = getters.connections.filter((c) => c.Status == 'Accepted');
        for (const connection of acceptedConnections) {
          await this.dispatch('getSubscribers', connection.id);
          let subscribers = getters.subscribers;

          connectedAppSub.AppSubscribers[connection.ConsumerConnectionDetails.OrganizationName] =
            subscribers.AppSubscribers;
          connectedAppSub.RmsConsumers['All Consumers'].push({
            Name: connection.ConsumerConnectionDetails.OrganizationName,
            id: connection.ConsumerConnectionDetails.OrganizationId,
          });
        }
      }

      const config = getters.config;
      const subscribers = getters.users;

      connectedAppSub.AppSubscribers[config.Name] = subscribers;

      if (getters.currentUserIsConsumer) {
        connectedAppSub.RmsConsumers['All Consumers'].push(config);
      }

      commit('setConnectedSubscribers', connectedAppSub);
      return connectedAppSub;
    },
  },
};
